/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Action_EventsInputs */

const en_footer_action_events = /** @type {(inputs: Footer_Action_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events`)
};

/**
* | output |
* | --- |
* | "Events" |
*
* @param {Footer_Action_EventsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_action_events = /** @type {((inputs?: Footer_Action_EventsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Action_EventsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_action_events(inputs)
});